import { AfterViewInit, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import type { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs';
import { MuiButtonAppearanceEnum } from '../button';
import { MuiI18nProvider } from '../i18n';

interface MuiBasicModalButtonConfig {
  label?: string;
  returnValue?: any;
  appearance?: MuiButtonAppearanceEnum;
}

export interface MuiBasicModalOptions extends NgbModalOptions {
  // Either give the display text or disable the button
  showCloseButton?: boolean;
  confirmButton?: MuiBasicModalButtonConfig;
  dismissButton?: MuiBasicModalButtonConfig | false;
}

@Component({
  selector: 'mui-modal',
  templateUrl: './mui-basic-modal.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `
  ]
})
export class MuiBasicModal implements OnInit, AfterViewInit {
  @ViewChild('confirmBtn', { static: true, read: ElementRef })
  private _confirmBtn!: ElementRef;

  /* Todo: Make this required once we migrate to Angular 16. */
  title!: string;
  titleId: string | null = null;
  message?: string;
  content?: TemplateRef<any>;
  closeButton = false;

  confirmButtonConfig: MuiBasicModalButtonConfig = {
    returnValue: true,
    appearance: MuiButtonAppearanceEnum.PRIMARY
  };

  dismissButton = false;
  dismissButtonConfig: MuiBasicModalButtonConfig = {
    returnValue: false,
    appearance: MuiButtonAppearanceEnum.SECONDARY
  };

  constructor(public modal: NgbActiveModal, private _i18n: MuiI18nProvider) {
    this._i18n
      .modal()
      .pipe(take(1))
      .subscribe((t) => {
        this.confirmButtonConfig.label = t.basicConfirmButton;
        this.dismissButtonConfig.label = t.basicDismissButton;
      });
  }

  ngOnInit(): void {
    if (this.message && this.content) {
      console.warn(
        'MuiBasicModalComponent: Both message and content properties have been set on this component \
instance. This component is designed to either display a simple message or some content, but not both.'
      );
    }
  }

  ngAfterViewInit(): void {
    this._confirmBtn.nativeElement.focus({ preventScroll: true });
  }
}
